import React from "react";
import PropTypes from "prop-types";

import AlarmClock from "images/icons/fi-rr-alarm-clock.inline.svg";
import Megaphone from "images/icons/fi-rr-megaphone.inline.svg";

const ProgramCapacity = ({
  programCapacityText,
  outerContainerClass = "",
  headerClass = "h6",
  headerTitleClass = "planet:!text-gray-generic",
  alarmIconClass = "w-5 h-5 fill-yellow-lighten planet:fill-green-standard",
  megaPhoneIconClass = "w-5 h-5 fill-yellow-lighten planet:fill-green-standard"
}) => {
  return (
    <>
      <div
        className={`popular-location flex sm:items-center ${outerContainerClass}`}
      >
        <div className="flex sm:items-center gap-x-2 sm:gap-x-3">
          {programCapacityText[0] === "almost_full" ? (
            <AlarmClock className={alarmIconClass} />
          ) : (
            <Megaphone className={megaPhoneIconClass} />
          )}
          <div
            className={headerClass}
            dangerouslySetInnerHTML={{
              __html: "Popular program."
            }}
          />
        </div>
        <div
          className={`${headerClass} pl-1 ${headerTitleClass}`}
          dangerouslySetInnerHTML={{
            __html: `${programCapacityText[1]}.`
          }}
        />
      </div>
    </>
  );
};

ProgramCapacity.propTypes = {
  programCapacity: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
};

export default ProgramCapacity;
